// This code assumes a Light Mode default
function checkColor() {
  if (
    /* This condition checks whether the user has set a site preference for dark mode OR a OS-level preference for Dark Mode AND no site preference */
    localStorage.getItem('color-mode') === 'dark' ||
    (window.matchMedia('(prefers-color-scheme: dark)').matches &&
     !localStorage.getItem('color-mode'))) {
    // if true, set the site to Dark Mode
    document.documentElement.setAttribute('color-mode', 'dark')
  }
}
checkColor();

window.addEventListener('DOMContentLoaded', (event) => {
// const icosa = document.getElementById("icosahedron");
  if (
    /* This condition checks whether the user has set a site preference for dark mode OR a OS-level preference for Dark Mode AND no site preference */
    localStorage.getItem('color-mode') === 'dark' ||
    (window.matchMedia('(prefers-color-scheme: dark)').matches &&
     !localStorage.getItem('color-mode'))) {
    // if true, set the site to Dark Mode
    // icosa.setAttribute("data", "scripts/icosahedron_dark.html");
  }

const toggleColorMode = e => {
  // Switch to Light Mode
  if (e.currentTarget.classList.contains("light--hidden")) {
 	  // Sets the custom HTML attribute
    document.documentElement.setAttribute("color-mode", "light");
    // icosa.setAttribute("data", "scripts/icosahedron.html");

	  //Sets the user's preference in local storage
    localStorage.setItem("color-mode", "light")
    return;
}
  
  /* Switch to Dark Mode
  Sets the custom HTML attribute */
  document.documentElement.setAttribute("color-mode", "dark");
  // icosa.setAttribute("data", "scripts/icosahedron_dark.html");

// Sets the user's preference in local storage
localStorage.setItem("color-mode", "dark");
};

// Get the buttons in the DOM
let toggleIcons = document.querySelectorAll("#darkmode, #lightmode");
// Set up event listeners
toggleIcons.forEach(i => {
    i.addEventListener("click", toggleColorMode);
}); 

});